<template>
  <div
    :class="{ 'left-nav-collapsed': leftNavCollapsed, isMobile }"
    class="page-wrapper w-100 h-100"
  >
    <mobile-header
      v-if="isMobile"
      @toggle-left-nav="onLeftNavToggle"
    ></mobile-header>
    <div class="app-wrapper" :class="$mq" style="height: 100%">
      <left-nav
        v-if="!isMobile || leftNavToggle"
        class="sidebar-wrapper"
        :collapsed="leftNavCollapsed"
      ></left-nav>
      <notifications group="general" position="bottom left" />
      <div class="main-content-wrapper">
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </div>

      <div
        v-if="shouldShowReadOnlyBanner || shouldShowCustomerDataWarningBanner"
        class="banner-container d-flex"
      >
        <div
          v-if="shouldShowReadOnlyBanner"
          class="banner banner--info"
          data-testid="read-only-banner"
        >
          This workspace is in read-only mode
        </div>
        <div
          v-if="shouldShowCustomerDataWarningBanner"
          class="banner banner--warning"
          data-testid="customer-data-warning-banner"
        >
          Customer account. Don't upload or change anything.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftNav from './navigation/LeftNav';
import MobileHeader from './navigation/MobileHeader';
import { isInternalStaff } from '@/utils/user';

export default {
  components: {
    LeftNav,
    MobileHeader,
  },
  data: () => ({
    leftNavToggle: false,
  }),
  computed: {
    shouldShowReadOnlyBanner() {
      // If the feature flag is on, we want to show this message to all users
      // including Inscribe staff
      return this.$store.state.featureFlagsStore.featureFlags
        .block_upload_access;
    },
    shouldShowCustomerDataWarningBanner() {
      return (
        this.$store.state.currentUser?.is_superuser &&
        this.$store.state.customers.selectedCustomer?.creator &&
        !isInternalStaff(this.$store.state.customers.selectedCustomer.creator)
      );
    },
    leftNavCollapsed() {
      return ['small1'].includes(this.$mq);
    },
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'small0';
    },
  },
  methods: {
    onLeftNavToggle() {
      this.leftNavToggle = !this.leftNavToggle;
    },
  },
};
</script>

<style lang="scss">
$leftNavWidth: 240px;
$leftNavWidthCollapsed: 64px;

.main-content-wrapper {
  height: 100%;
}

.page-wrapper {
  &.left-nav-collapsed {
    .sidebar-wrapper {
      width: $leftNavWidthCollapsed;
    }
  }
}

.main-content-wrapper {
  height: 100%;
}

.content_card {
  min-height: 100%;
  background: $color-off-white;
  padding: 32px;
}

.sidebar-wrapper {
  z-index: 1000;
  bottom: 0;
  left: 0;
  position: fixed;
  top: 0;
  width: $leftNavWidth;
  overflow: hidden;
}

.app-wrapper {
  margin-left: 64px;
  overflow-x: hidden;
}

.app-wrapper.small0,
.app-wrapper.mobile {
  margin-left: 0;
}

.app-wrapper.small2,
.app-wrapper.mediumLarge,
.app-wrapper.small3,
.app-wrapper.lg {
  margin-left: $leftNavWidth;
}

.notification div {
  font-size: 1rem !important;
}

.notification-wrapper {
  margin-top: 20px;
}

.banner-container {
  position: fixed;
  z-index: 100000;
  bottom: 0;
  right: 260px;

  &:hover {
    cursor: default;
    display: none !important;
  }

  .banner {
    color: #fff;
    text-align: center;
    font-size: 0.95rem;
    opacity: 80%;
    padding: 8px;

    &:first-child {
      border-radius: 5px 5px 0px 0px;
    }

    &--info {
      background: gray;
    }

    &--warning {
      background: red;
    }
  }
}

@media only screen and (max-width: 680px) {
  .button-desc {
    display: none !important;
  }
}

.btn div {
  display: inline;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.no-gutters.col,
.no-gutters[class*='col-'] {
  padding-right: 0;
  padding-left: 0;
}

.good {
  background-color: $color-green !important;
  color: $color-white !important;
}

.bad {
  background-color: $color-warning-red !important;
  color: $color-white !important;
}

.summary-list .unknown {
  background-color: $color-navy-blue-60 !important;
  color: $color-white !important;
}
.all-copy {
  -webkit-user-select: all; /* Chrome all / Safari all */
  -moz-user-select: all; /* Firefox all */
  -ms-user-select: all; /* IE 10+ */
  user-select: all; /* Likely future */
  font-family: courier;
  white-space: pre-line;
}
.form-control {
  height: inherit;
}
.vs__dropdown-menu {
  max-height: 250px !important;
}

/* TwentyTwenty */
.twentytwenty-before-label,
.twentytwenty-after-label {
  background: rgba(30, 30, 30, 0.4) !important;
  top: calc(10% - 0.4em - 5px) !important;
}
.faded {
  opacity: 0.7;
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

$twentytwenty-handle-color: $color-navy-blue;
.twentytwenty-container .twentytwenty-overlay {
  background: rgba(73, 94, 115, 0.5) !important; //$color-navy-blue-80
}

.twentytwenty-container .twentytwenty-handle:after {
  border-color: $twentytwenty-handle-color !important;
  bottom: 35px !important;
}

.twentytwenty-container .twentytwenty-handle:before {
  border-color: $twentytwenty-handle-color !important;
  top: 35px !important;
}

.twentytwenty-container .twentytwenty-handle {
  border-color: $twentytwenty-handle-color !important;
  margin-left: 0 !important;
}

.twentytwenty-arrow-left {
  border-right-color: $twentytwenty-handle-color !important;
  top: 6px !important;
  left: 4px !important;
}

.twentytwenty-arrow-right {
  border-left-color: $twentytwenty-handle-color !important;
  bottom: 14px !important;
  left: 18px !important;
}

$container-max-height: calc(100vh - #{$margin-modal-y * 2} - 130px);
$container-max-height-with-actions: calc(
  100vh - #{$margin-modal-y * 2} - 130px - 172px
);
.pdf-viewer {
  max-height: $container-max-height;

  &:not(.page-list) {
    min-height: $container-max-height;
  }

  iframe {
    height: $container-max-height;
  }

  position: relative;

  .pdf-wrapper {
    overflow: auto;
    max-height: 100%;
    max-width: 100%;
    width: 100%;

    img {
      display: block;
      margin: auto;
    }
  }
}

.document-actions + .pdf-viewer.page-list {
  max-height: $container-max-height-with-actions;
}
</style>
